/**
 * Copyright (c) Qwoach LLC 2024. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Artem Bogush <artem@qwoach.com> on 9.07.24
 *
 */
import BaseObject from "@shared/BaseObject.js";
import CurrencyItem from "@shared/Profile/CurrencyItem";

export default class PlanSwitchPreview extends BaseObject {

	currencyCode: string = CurrencyItem.USD.code
	immediateAmount: number = null;
	immediateDateTs: number = null
	nextAmount: number = null
	nextDateTs: number = null

}
